const MONTHS: Record<string, number> = {
  january: 0,
  jan: 0,
  february: 1,
  feb: 1,
  march: 2,
  mar: 2,
  april: 3,
  apr: 3,
  may: 4,
  june: 5,
  jun: 5,
  july: 6,
  jul: 6,
  august: 7,
  aug: 7,
  september: 8,
  sep: 8,
  sept: 8,
  october: 9,
  oct: 9,
  november: 10,
  nov: 10,
  december: 11,
  dec: 11,
};

const MONTH_DATE_PATTERN = new RegExp(
  `\\b(${Object.keys(MONTHS).join('|')})\\.?\\s+(\\d{1,2})(?:st|nd|rd|th)?(?:,?\\s+(20\\d{2}))?\\b`,
  'i',
);

const DAY_MS = 24 * 60 * 60 * 1000;
const MAX_INFERRED_AGE_DAYS = 180;

export function getPastTitleDateWarning(title: string, now = new Date()): string | null {
  const match = title.match(MONTH_DATE_PATTERN);
  if (!match) return null;

  const month = MONTHS[match[1].toLowerCase()];
  const day = Number(match[2]);
  const explicitYear = match[3] ? Number(match[3]) : null;
  const year = explicitYear ?? now.getUTCFullYear();
  const mentionedDate = new Date(Date.UTC(year, month, day));

  if (
    mentionedDate.getUTCFullYear() !== year
    || mentionedDate.getUTCMonth() !== month
    || mentionedDate.getUTCDate() !== day
  ) {
    return null;
  }

  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const ageDays = Math.floor((today - mentionedDate.getTime()) / DAY_MS);
  if (ageDays <= 0 || (!explicitYear && ageDays > MAX_INFERRED_AGE_DAYS)) return null;

  const label = mentionedDate.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    ...(explicitYear ? { year: 'numeric' } : {}),
    timeZone: 'UTC',
  });
  return `${label} has passed—verify that this listing is still available.`;
}
